import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
  /**
   * Angular DomSanitizer for bypassing security and trusting the provided HTML.
   */
  private readonly domSanitizer = inject(DomSanitizer);

  /**
   * Transforms a string into trusted HTML using DomSanitizer.
   * @param value The HTML string to sanitize.
   * @returns The trusted SafeHtml value.
   */
  transform(value: string): SafeHtml {
    if (!value) {
      return '';
    }

    return this.domSanitizer.bypassSecurityTrustHtml(value);
  }
}

@Pipe({
  name: 'safeUrl',
  standalone: true,
})
export class SafeUrlPipe implements PipeTransform {
  /**
   * Angular DomSanitizer for bypassing security and trusting the provided URL.
   */
  private readonly domSanitizer = inject(DomSanitizer);

  /**
   * Transforms a string into a trusted resource URL using DomSanitizer.
   * @param value The URL string to sanitize.
   * @returns The trusted SafeUrl value.
   */
  transform(value: string): SafeUrl {
    if (!value) {
      return '';
    }

    return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
  }
}
